import { useEffect, useState } from "react";

export const useTextSwitcher = (texts, interval) => {
    const [textIndex, setTextIndex] = useState(0);
    
    useEffect(() => {
        if (textIndex === texts.length - 1) return;
        const intervalId = setInterval(() => {
            setTextIndex((prevIndex) => {
                if (prevIndex < texts.length - 1) {
                    return prevIndex + 1;
                }
                return prevIndex;
            });
        }, interval);

        return () => clearInterval(intervalId);
    }, [textIndex, texts, interval]);

    return texts[textIndex];
}